import { AfterViewInit, Component, Input, OnChanges, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import * as THREE from 'three';
// import { FontLoader } from 'three/examples/jsm/loaders/FontLoader';
// import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry';
import {
  NgxCameraComponent,
  NgxRendererComponent,
  NgxSceneComponent,
  NgxMeshComponent  // ✅ este es el tipo correcto
} from 'ngx3js';

export interface WaveParams {
  height: number;
  frequency: number;
  speed: number;
}

export interface LiquidLayer {
  label?: string;
  color: string;
  percentage: number;
  mesh?: THREE.Mesh;
  basePositions?: Float32Array;
  waveParams?: WaveParams[];
}

@Component({
  selector: 'app-view-warehouse-cylinder-multi',
  templateUrl: './view-warehouse-cylinder-multi.component.html',
  styleUrls: ['./view-warehouse-cylinder-multi.component.scss']
})
export class ViewWarehouseCylinderMultiComponent implements OnInit, OnChanges {
  @ViewChild('renderer3d', { static: false }) rendererComp!: NgxRendererComponent;
  @ViewChild('camera', { static: false }) camera!: NgxCameraComponent;
  @ViewChild('scene', { static: false }) scene!: NgxSceneComponent;
  @ViewChild('containerMesh', { static: false }) containerMesh!: NgxMeshComponent;
  @ViewChild('coneMesh', { static: false }) coneMesh!: NgxMeshComponent;
  @ViewChildren('liquidMeshes') liquidMeshes!: QueryList<NgxMeshComponent>;
  @ViewChild('measureLineGrowth', { static: false }) measureLineGrowth!: NgxMeshComponent;

  @Input() scalePercentage: number = 2;
  @Input() activeModal: boolean = true;
  @Input() title: string = "Bodega";
  @Input() radius: number = 10;
  @Input() length: number = 25;
  @Input() percentageLine: number = 0.3 + 0.13 + 0.2;
  @Input() liquidColor: string = "#0086E3";
  @Input() liquids: LiquidLayer[] = [
    { color: '#00E300', percentage: 0.3, waveParams: [{ height: 0.05, frequency: 2, speed: 4 }] },
    { color: '#FFFF00', percentage: 0.13, waveParams: [{ height: 0.05, frequency: 2, speed: 4 }] },
    { color: '#ff5555', percentage: 0.2, waveParams: [{ height: 0.05, frequency: 2, speed: 4 }] },
  ];
  @Input() allFig: boolean = true;

  angle = 0;
  mathPiValue: number = Math.PI;
  minusMathPiValue: number = this.mathPiValue * (-1);
  gradeCos45 = Math.cos(Math.PI / 8)
  gradeSin45 = Math.sin(Math.PI / 8)

  // Tooltip
  tooltipVisible = false;
  tooltipX = 0;
  tooltipY = 0;

  private raycaster = new THREE.Raycaster();
  private mouse = new THREE.Vector2();
  private originalColor: THREE.Color | null = null;
  private clock = new THREE.Clock();

  private growthValue = 0; // valor actual de crecimiento (0 → 1)
  @Input() isGrowing = true; // controla si sigue animando
  private growthSpeed = 0.35; // velocidad del crecimiento (ajusta a gusto)

  // Control de crecimiento secuencial
  private currentLiquidIndex = 0;
  private growthSpeeds: number[] = []; // velocidad de crecimiento para cada líquido
  private growthValues: number[] = []; // progreso de crecimiento (0 a porcentaje)
  private isAnimatingLiquids = true;   // bandera general

  measurementLinePoints = new Float32Array([
    this.radius + 3, -this.length / 2, 0, // inicio
    this.radius + 3, this.length / 2, 0  // fin
  ]);

  font: THREE.Font | null = null;

  ngOnInit() {
    if (!this.isWebGLAvailable()) {
      alert('Tu navegador no soporta WebGL. Por favor, actualízalo o usa otro.');
      return;
    }
    
    if (this.isWebGLAvailable()) {
      // Inicializa tu escena
      this.startGrowth();
    } else {
      console.error('WebGL no está disponible en este navegador.');
    }
  }

  isWebGLAvailable(): boolean {
    try {
      const canvas = document.createElement('canvas');
      const gl =
        canvas.getContext('webgl2') ||
        canvas.getContext('webgl') ||
        canvas.getContext('experimental-webgl');
      return !!gl;
    } catch (e) {
      return false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['percentageLine'] && !changes['percentageLine'].firstChange) {
      // cuando el porcentaje cambia desde el padre, reiniciamos la animación
      this.startGrowth();
    }
  }

  startGrowth() {
    this.growthValue = 0;
    this.isGrowing = true;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.growthSpeeds = this.liquids.map(() => 0.6); // velocidad por líquido
      this.growthValues = this.liquids.map(() => 0);   // empieza desde 0%
      this.currentLiquidIndex = 0;
      this.isAnimatingLiquids = true;

      this.adjustCameraToCylinder();
      this.initializeLiquids(); // Nueva función para inicializar basePositions
      // this.createMarkLabels();

      const labelPosition = new THREE.Vector3(
        this.radius + 5, // Ajusta esta distancia según tu escena
        0,       // Centrado verticalmente con el cilindro
        this.radius + 5
      );
      // this.addTextLabel("DUO Xd", labelPosition);
    }, 100);
    const mesh = this.containerMesh?.getMesh();
    if (mesh) {
      const mat = mesh.material as THREE.MeshStandardMaterial;
      this.originalColor = mat.color.clone();
    }
  }

  private initializeLiquids(): void {
    this.liquids.forEach((liquid, i) => {
      const mesh = this.getMesh(i);
      if (mesh) {
        liquid.mesh = mesh;
        const geometry = mesh.geometry as THREE.BufferGeometry;
        liquid.basePositions = geometry.attributes.position.array.slice() as Float32Array;

        // 📍 Crear etiqueta de texto al lado del líquido
        // const labelPosition = new THREE.Vector3(
        //   mesh.position.x + 0.5, // Ajusta esta distancia según tu escena
        //   mesh.position.y,       // Centrado verticalmente con el cilindro
        //   mesh.position.z
        // );
        // this.addTextLabel("liquid.name", labelPosition);
      }
    });
  }

  private adjustCameraToCylinder() {
    if (!this.camera) return;

    // Tomamos el cilindro como referencia
    const maxDimension = Math.max(this.radius * 2, this.length); // ancho o alto
    const distanceFactor = 2; // ajusta la distancia para que se vea un poco separado

    // Posición de la cámara inicial (en diagonal para ver el cilindro completo)
    const camDistance = maxDimension * distanceFactor;
    const angle = Math.PI / 4; // 45 grados para eje X y Z

    let x = -camDistance * Math.cos(angle);
    let y = maxDimension / 3;     // altura central del cilindro
    let z = -camDistance * Math.sin(angle);


    this.camera.setPosition(x, y, z);
    // this.camera.setPosition(Math.cos(angle), 0, -90);

    // Apuntar la cámara al centro del cilindro
    const mesh = this.containerMesh?.getMesh();
    if (mesh) {
      const bbox = new THREE.Box3().setFromObject(mesh);
      const center = new THREE.Vector3();
      bbox.getCenter(center);

      // this.camera.lookAt(center.x, center.y, center.z);
      this.camera.setLookat(center.x, center.y, center.z);
    }

    // Opcional: actualizar controles si usas orbit
    this.rendererComp?.getRenderControl()?.updateInputParams;
  }

  onMouseMove(event: MouseEvent) {
    const canvas = this.rendererComp.getRenderer().domElement;
    const rect = canvas.getBoundingClientRect();

    // Coordenadas normalizadas [-1,1] para raycaster
    this.mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    this.mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

    this.checkIntersection(event.clientX - rect.left, event.clientY - rect.top);
  }

  private checkIntersection(mouseX: number, mouseY: number) {
    if (!this.camera || !this.containerMesh) return;

    const cam = this.camera.getCamera();
    this.raycaster.setFromCamera(this.mouse, cam);

    const mesh = this.containerMesh.getMesh();
    if (!mesh) return;

    const intersects = this.raycaster.intersectObject(mesh);

    const mat = mesh.material as THREE.MeshStandardMaterial;
    if (intersects.length > 0) {
      this.tooltipVisible = true;

      // Posición exacta del mouse dentro del canvas
      this.tooltipX = mouseX;
      this.tooltipY = mouseY - 20; // 20px por encima del cursor

      mat.color.set('#FFFF99'); // amarillo semi
    } else {
      this.tooltipVisible = false;
      if (this.originalColor) mat.color.copy(this.originalColor);
    }
  }

  private updateTooltipCenter() {
    const mesh = this.containerMesh?.getMesh();
    const cam = this.camera?.getCamera();
    const renderer = this.rendererComp?.getRenderer();
    if (!mesh || !cam || !renderer) return;

    // Calculamos el centro del mesh
    const bbox = new THREE.Box3().setFromObject(mesh);
    const center = new THREE.Vector3();
    bbox.getCenter(center);

    // Proyectamos el centro a coordenadas normalizadas de pantalla
    const vector = center.clone().project(cam);

    const widthHalf = renderer.domElement.clientWidth / 2;
    const heightHalf = renderer.domElement.clientHeight / 2;

    // Convertimos a coordenadas en pixels dentro del canvas
    this.tooltipX = vector.x * widthHalf + widthHalf;
    this.tooltipY = -vector.y * heightHalf + heightHalf;

    this.tooltipVisible = false;
  }

  onAnimate(event?: any) {
    const delta = this.clock.getDelta();

    // this.animateLiquidsGrowth(event);
    this.growthProgressAnimated(event);

    // 🔹 Rotación automática del cilindro contenedor
    const container = this.containerMesh?.getMesh();
    const containerCone = this.coneMesh?.getMesh();
    if (container && containerCone) {
      container.rotation.y += 0.1; // velocidad del giro (ajusta según prefieras)
      containerCone.rotation.y += 0.1; // velocidad del giro (ajusta según prefieras)
    }
    this.animatedLiquids(event);

  }

  animatedLiquids(event?: any) {
    const time = this.clock.getElapsedTime();

    this.liquids.forEach((liquid, index) => {
      if (!liquid.mesh || !liquid.basePositions) return;

      const geometry = liquid.mesh.geometry as THREE.BufferGeometry;
      const position = geometry.attributes.position as THREE.BufferAttribute;
      // Copia basePositions para no modificar el original cada frame
      const currentPositions = liquid.basePositions.slice();
      for (let i = 0; i < position.count; i++) {
        const x = currentPositions[i * 3];
        const y = currentPositions[i * 3 + 1];
        const z = currentPositions[i * 3 + 2];
        // Solo deformamos la superficie superior del líquido actual
        const liquidTopY = -this.length / 2 + this.length * liquid.percentage;
        if (y > liquidTopY - 0.5) {  // Ajusta el umbral si es necesario
          let wave = 0;
          liquid.waveParams?.forEach(p => {
            wave += Math.sin(x * p.frequency + time * p.speed) * p.height;
            wave += Math.cos(z * p.frequency + time * p.speed * 0.8) * p.height;
          });
          position.setY(i, y + wave);
        } else {
          // Restaura posición base para vértices no afectados
          position.setXYZ(i, x, y, z);
        }
      }
      position.needsUpdate = true;
      geometry.computeVertexNormals();
    });
  }

  growthProgressAnimated(event?: any) {
    if (this.isGrowing && this.measureLineGrowth) {
      this.growthValue += this.growthSpeed * event.delta; // crece suavemente con el tiempo
      if (this.growthValue >= this.percentageLine) {
        this.growthValue = this.percentageLine;
        this.isGrowing = false; // detener animación al llegar
      }

      // Actualizamos el mesh
      const mesh = this.measureLineGrowth.getMesh();
      if (mesh) {
        const targetHeight = this.length * this.growthValue;
        const cylinder = mesh as THREE.Mesh;
        const geometry = cylinder.geometry as THREE.CylinderGeometry;

        // ⚙️ Actualizar altura (recreamos la geometría)
        cylinder.geometry.dispose();
        cylinder.geometry = new THREE.CylinderGeometry(0.15, 0.15, targetHeight, 16);
        cylinder.position.y = -(this.length / 2) + (targetHeight / 2);
        // cylinder.position.y = targetHeight / 2;
      }
    }
  }

  animateLiquidsGrowth(event?: any) {
    if (!this.isAnimatingLiquids) return;

    const i = this.currentLiquidIndex;
    if (i >= this.liquids.length) {
      this.isAnimatingLiquids = false;
      return; // todos los líquidos terminaron
    }

    const liquid = this.liquids[i];

    this.growthValues[i] += this.growthSpeeds[i] * event.delta;
    if (this.growthValues[i] >= liquid.percentage) {
      this.growthValues[i] = liquid.percentage;
    }

    if (!liquid.mesh) return;

    const cylinder = liquid.mesh as THREE.Mesh;
    const targetHeight = this.length * this.growthValues[i];
    const geometry = cylinder.geometry as THREE.CylinderGeometry;

    cylinder.geometry = new THREE.CylinderGeometry(this.radius * 0.95, this.radius * 0.95, targetHeight, 64);
    // cylinder.position.y = -this.length / 2 + targetHeight / 2;

    // Altura actual del líquido animado
    // const currentHeight = Math.min(
    //   this.length * this.growthValues[i],
    //   this.length * liquid.percentage
    // );

    // // Crear nueva geometría con la altura actual
    // const newGeometry = new THREE.CylinderGeometry(
    //   this.radius * 0.95,
    //   this.radius * 0.95,
    //   currentHeight,
    //   64
    // );
    // cylinder.geometry.dispose();
    // cylinder.geometry = newGeometry;

    // // Posicionar correctamente en el eje Y (desde abajo)
    // let y = -(this.length / 2);
    // for (let j = 0; j < i; j++) {
    //   y += this.liquids[j].percentage * this.length;
    // }
    // y += currentHeight / 2;
    // cylinder.position.y = y;

    // Verificar si este líquido ya terminó de crecer
    if (this.growthValues[i] >= liquid.percentage) {
      this.currentLiquidIndex++;
    }
  }


  private getMesh(index: number): THREE.Mesh | null {
    const meshRefs = this.liquidMeshes?.toArray(); // si usas ViewChildren
    if (!meshRefs || !meshRefs[index]) return null;
    return meshRefs[index].getMesh();
  }

  getLiquidPosition(index: number) {
    let y = -(this.length / 2); // parte inferior del cilindro
    for (let i = 0; i < index; i++) {
      y += this.liquids[i].percentage * this.length; // sumamos alturas de líquidos anteriores
    }
    // Centrar el líquido actual sobre su propio alto
    y += (this.liquids[index].percentage * this.length) / 2 + 0.001 * index;
    return y;
  }

  getMeasurementMarks(): number[] {
    const markSpacing = this.length / 8; // cada 5 unidades
    const marks = [];
    for (let y = -this.length / 2; y <= this.length / 2; y += markSpacing) {
      marks.push(y);
    }
    return marks;
  }

  getPercentageMarks(): number[] {
    const marks = [];
    for (let i = 0; i < this.liquids.length; i++) {
      let y = -(this.length / 2); // parte inferior del cilindro
      for (let j = 0; j < i; j++) {
        y += this.liquids[j].percentage * this.length; // sumamos alturas de líquidos anteriores
      }
      // Centrar el líquido actual sobre su propio alto
      y += (this.liquids[i].percentage * this.length) / 2 + 0.001 * i;
      marks.push(y);
    }
    return marks;
  }
}
